import { System } from '@ecs/System';
import { Position } from '@components/Position';
import { Velocity } from '@components/Velocity';
import { Tag } from '@components/Tag';

export class SeparationSystem extends System {
  private readonly minSeparation = 60; // Minimum distance between ships
  private readonly separationStrength = 2.0; // How strongly ships push apart

  update(_deltaTime: number): void {
    const players = this.getEntitiesWithComponents(Position, Velocity, Tag).filter(
      entity => entity.getComponent(Tag)!.value === 'player'
    );

    // Apply separation forces between all player ships
    for (let i = 0; i < players.length; i++) {
      const shipA = players[i];
      const posA = shipA.getComponent(Position)!;

      for (let j = 0; j < players.length; j++) {
        if (i === j) continue;

        const shipB = players[j];
        const posB = shipB.getComponent(Position)!;

        const dx = posA.x - posB.x;
        const dy = posA.y - posB.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        // Apply separation by adjusting position directly if too close
        if (distance < this.minSeparation) {
          if (distance === 0) {
            // Special case: entities at exact same position
            // Apply a small random separation to break the tie
            const angle = Math.random() * Math.PI * 2;
            const separationForce = this.separationStrength;
            posA.x += Math.cos(angle) * separationForce;
            posA.y += Math.sin(angle) * separationForce;
          } else {
            // Calculate repulsion force (stronger when closer)
            const force = ((this.minSeparation - distance) / this.minSeparation) * this.separationStrength;
            
            // Apply separation directly to position for immediate response
            posA.x += (dx / distance) * force;
            posA.y += (dy / distance) * force;
          }
        }
      }
    }
  }
}